import { Box, Checkbox, Grid, Typography } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenDateTimePicker from '../../../../global_components/KenDateTimePicker';
import {
  EVENT_TYPES,
  RECURRENT_DAYS,
} from '../../../../Utils/helper/schedulerHelper';
import KenButton from '../../../../global_components/KenButton';
import { createBookedSlot, sessionCUD } from '../../../../Utils/apiServices';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { useToggleStyles } from '../SessionScheduler';
import { useAppContext } from '../../../../Utils/context';
import dayjs from '../../../../Utils/dayjs';
import { getCampusHolidaysData } from '../../../../Utils/apiServices';
import { useSSR } from 'react-i18next';
import KenCard from '../../../../global_components/KenCard';
import moment from 'moment';
import '../../AddSubject/styles.scss';
const reducer = function (state, action) {
  switch (action.type) {
    case 'update':
      return { ...state, [action.key]: action.value };

    case 'facultyOptions':
      return {
        ...state,
        facultyOptions: action?.value?.map((f) => ({
          label: f.facultyName,
          value: f.id,
        })),
      };
    case 'faciltiyOptions':
      return {
        ...state,
        facilityOptions: action?.value?.map((f) => ({
          label: f.facilityName,
          value: f.id,
        })),
      };

    case 'courseVersionData':
      return {
        ...state,
        courseVersionData: action.value,
        subjectOptions: action.value?.map((s) => ({
          value: s.id,
          label: s.courseName,
        })),
      };

    case 'subjectSelected':
      return {
        ...state,
        subject: action.value,
        section: '',
        sectionOptions: getSectionOptions(
          state.courseVersionData,
          action.value
        ),
      };

    default:
      return state;
  }
};

const getSectionOptions = function (data = [], subjectId) {
  if (!subjectId) {
    return [];
  }
  return data
    ?.find((e) => e.id === subjectId)
    ?.courseOffering?.map((c) => ({
      label: c.courseSectionId,
      value: c.id,
    }));
};

export default function SessionCreateUpdate(props) {
  const {
    faculties = [],
    facilities = [],
    activityTypes = [],
    courseVersionData = [],
    onCancel,
    onSuccess,
    term,
    event = { isCreateFromReference: false },
  } = props;
  console.log('props', props);
  const [holidayData, setHolidayData] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [holidayView, setHolidayView] = useState(false);
  const [reqAllocView, setReqAllocView] = useState(false);
  const [requiredItem, setRequiredItem] = useState();
  const [allocatedItem, setAllocatedItem] = useState();
  const toggleClasses = useToggleStyles();

  useEffect(() => {
    dispatch({ type: 'faciltiyOptions', value: facilities });
  }, [facilities]);
  useEffect(() => {
    dispatch({ type: 'facultyOptions', value: faculties });
  }, [faculties]);
  useEffect(() => {
    dispatch({ type: 'courseVersionData', value: courseVersionData });
  }, [courseVersionData]);

  useEffect(() => {
    getCampusHolidaysData('').then((res) => {
      if (res?.length > 0) {
        setHolidayData(res);
      }
    });
  }, []);

  const subjectId =
    event?.SubjectPlanner?.courseVersionId || event?.courseVersionId || '';
  const [state, dispatch] = useReducer(reducer, {
    ...event,
    activity: event?.activity || event?.activityType || '',
    faculty: event?.faculty1Id || '',
    facility: event?.facilityId || '',
    subject: subjectId,
    section:
      event?.SubjectPlanner?.courseOfferingId || event?.courseOfferingId || '',
    sectionOptions: subjectId
      ? getSectionOptions(courseVersionData, subjectId)
      : [],
  });
  const {
    activity = '',
    startDate = '',
    startTime = '',
    endDate = '',
    endTime = '',
    recurrent = false,
    subject = '',
    section = '',
    faculty = '',
    facility = '',
    facultyOptions = [],
    facilityOptions = [],
    subjectOptions = [],
    recurrentDays = [],
    sectionOptions,
    id,
    isCreateFromReference,
    eventType,
  } = state;
  const [workingDays, setWorkingDays] = React.useState([]);
  useEffect(() => {
    if (courseVersionData?.length > 0) {
      if(courseVersionData[0]?.workingDays != null){
        let days = courseVersionData[0]?.workingDays.split(';');
        setWorkingDays(days);
      }
    }
  }, []);
  useEffect(() => {
    if (holidayData.length > 0 && startDate != '' && endDate != '') {
      setHolidayView(true);
      let start = moment(startDate);
      let end = moment(endDate);
      let holiday = [];
      let filteredList = [];
      holidayData.map((item) => {
        if (
          moment(item.startDate).isBetween(start, end) &&
          moment(item.endDate).isBetween(start, end)
        ) {
          holiday.push(item);
        }
      });
      console.log('holiday', holiday);
      setFilteredList(holiday);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (subject != '' && section != '') {
      setReqAllocView(true);
      const data = [];
      courseVersionData.forEach((item) => {
        if (item.id === subject) {
          data.push(item);
        }
      });
      if (activity != '') {
        Object.entries(data[0]?.Required).map((item) => {
          if (item[0] === activity) {
            setRequiredItem(item[1]);
          }
        });
        data[0].courseOffering.map((items) => {
          if (items.id === section) {
            Object.entries(items?.Allocated).map((el) => {
              if (el[0] === activity) {
                setAllocatedItem(el[1]);
              }
            });
          }
        });
      }
    }
  }, [subject, section, activity]);
  const {
    config: { orgTimeZone = 'Asia/Kolkata' } = {},
    handleSnackbarOpen,
    handleLoader,
  } = useAppContext();

  const onSubmit = () => {
    // if (eventType === EVENT_TYPES.ACTIVITY) {
    //   createActivity();
    // } else if (eventType === EVENT_TYPES.SESSION) {
    //   createSession();
    // }

    createSession();
  };

  const createSession = () => {
    const payload = {
      Operation: 'Create',
      Session: [
        {
          courseOfferingId: section,
          sessionId: id,
          activityType: activity,
          startDate:
            dayjs(`${startDate} ${startTime}`)
              .tz(orgTimeZone)
              .format('YYYY-MM-DDTHH:mm:ss.000') + 'Z',
          endDate:
            dayjs(`${endDate} ${endTime}`)
              .tz(orgTimeZone)
              .format('YYYY-MM-DDTHH:mm:ss.000') + 'Z',
          facultyId: faculty,
          facilityId: facility,
          daySelected: recurrentDays.join(';'),
        },
      ],
    };

    handleLoader(true);
    sessionCUD(payload)
      .then((res) => {
        handleLoader(false);
        if (res) {
          onSuccess();
          handleSnackbarOpen('success', 'Created Successfully');
        }
      })
      .catch((err) => {
        handleLoader(false);
        handleSnackbarOpen('error', 'Error saving details');
        console.log(err);
      });
  };

  const createActivity = () => {
    const payload = {
      Operation: 'Create',
      FacilityFacultyBooking: {
        termId: term,
        facultyId: faculty,
        facilityId: facility,
        // facilityBookingId: '',
        daySelected: recurrentDays.join(';'),
        courseVersionId: subject,
        courseOfferingId: section,
        academicPlannerActivityId: event?.academicPlannerActivityId || '',
        activityType: activity,
        startDate: `${startDate}T${startTime}:00.000Z`,
        endDate: `${endDate}T${endTime}:00.000Z`,
      },
    };

    handleLoader(true);
    createBookedSlot(payload)
      .then((res) => {
        // toast success
        handleLoader(false);
        if (res) {
          onSuccess();
          handleSnackbarOpen('success', 'Created Successfully');
        }
      })
      .catch((err) => {
        // toast error saving
        handleLoader(false);
        handleSnackbarOpen('error', 'Error saving details');
        console.log(err);
      });
  };

  return (
    <Box>
      <Box mb={2}>
        <Typography variant="h6">
          <b>Add Session</b>
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={12}>
          <KenSelectWrap
            disabled={isCreateFromReference}
            label="Type of sessions"
            options={activityTypes}
            value={activity}
            // dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'activity',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            // disabled={false}
            value={startDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'startDate',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'startTime'}
            label="Start Time"
            value={startTime}
            type="time"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'startTime',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            // disabled={false}
            value={endDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'endDate',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenDateTimePicker
            name={'endTime'}
            label="End Time"
            value={endTime}
            type="time"
            required={true}
            // defaultValue={startData}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'endTime',
                value: e.target.value,
              });
            }}
          />
        </Grid>
        {!id &&
          (eventType === EVENT_TYPES.ACTIVITY ||
            eventType === EVENT_TYPES.SESSION) && (
            <Grid item xs={12} md={12}>
              <Checkbox
                checked={recurrent}
                onChange={(e) => {
                  dispatch({
                    type: 'update',
                    key: 'recurrent',
                    value: !recurrent,
                  });
                }}
                color="secondary"
              />
              Recurrent Session
            </Grid>
          )}
        {recurrent && (
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              {workingDays.length > 0 ? (
                <>
                  <p style={{ paddingLeft: '16px', fontWeight: 600 }}>
                    Note: Working days of the term
                  </p>
                  <div style={{ display: 'flex', padding: '0px 16px 10px 0px' }}>
                    {workingDays.map((item, index) => {
                      return (
                        <p style={{ paddingLeft: '16px' }}>
                          {index + 1}. {item}
                        </p>
                      );
                    })}
                  </div>
                </>
              ) : null}
            </Grid>
            <Grid item xs={12} md={12}>
              <div style={{ display: 'flex', paddingLeft: '16px' }}>
                <ToggleButtonGroup
                  size="small"
                  color="primary"
                  value={recurrentDays}
                  onChange={(e, newV) => {
                    dispatch({
                      type: 'update',
                      key: 'recurrentDays',
                      value: newV,
                    });
                  }}
                  aria-label="text formatting"
                >
                  {RECURRENT_DAYS.map((d) => (
                    <ToggleButton
                      classes={toggleClasses}
                      value={d.value}
                      aria-label="bold"
                    >
                      {d.label}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </div>
            </Grid>
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            disabled={isCreateFromReference}
            label="Subject"
            options={subjectOptions}
            // disabled={false}
            value={subject}
            // dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'subjectSelected',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Section"
            options={sectionOptions}
            value={section}
            dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'section',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Faculty"
            options={facultyOptions}
            value={faculty}
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'faculty',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <KenSelectWrap
            label="Facility"
            options={facilityOptions}
            value={facility}
            dropdownColor="#FFFFFF"
            onChange={(e) => {
              dispatch({
                type: 'update',
                key: 'facility',
                value: e.target.value,
              });
            }}
            // styles={CustomStyle}
            required
          />
        </Grid>
      </Grid>
      {holidayView ? (
        <>
          <Typography style={{ marginTop: 20 }}>Holiday List</Typography>
          <Grid container xs={12} spacing={2} style={{ marginTop: 10 }}>
            <ol>
              {filteredList.map((item) => {
                return (
                  <li>
                    <Typography style={{ fontSize: 14, color: '#505F79' }}>
                      {item.holidayType} -{' '}
                      {moment(item.startDate, 'YYY-MM-DD').format('DD-MMM')} -{' '}
                      {moment(item.endDate, 'YYY-MM-DD').format('DD-MMM')}
                    </Typography>
                  </li>
                );
              })}
            </ol>
          </Grid>
        </>
      ) : null}
      {reqAllocView ? (
        <>
          <Typography style={{ marginTop: 10 }}>Required/Allocated</Typography>
          <Grid
            container
            xs={12}
            spacing={2}
            style={{ margin: '10px 0px 0px 10px' }}
          >
            <Grid container xs={6}>
              <Grid item xs={3}>
                Required
              </Grid>
              <Grid item xs={3}>
                {requiredItem}
              </Grid>
            </Grid>
            <Grid container xs={6}>
              <Grid item xs={3}>
                Allocated
              </Grid>
              <Grid item xs={3}>
                {allocatedItem}
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : null}

      <Box display="flex" justifyContent="end" mt={4}>
        <KenButton
          variant="secondary"
          onClick={onCancel}
          style={{ marginRight: 8 }}
        >
          Cancel
        </KenButton>
        <KenButton variant="primary" onClick={onSubmit}>
          Submit
        </KenButton>
      </Box>
    </Box>
  );
}
